import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  topPage()
}
function topPage() {
  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  if (document.getElementById('topMv')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('topMv')
    const sliderName = 'topMv'
    const topMvSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.15, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 10, //スライド同士の間隔を空ける
      centeredSlides: true, // 中央のスライドを基準にする

      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false, // 操作されたら停止する
        // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
        // stopOnLastSlide: true, // 最終スライドに到達したら停止する
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          slidesPerView: 3.4, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        },
      },
    })
  }
}
